import { StorySelector } from 'components/app/app-components/story-selector/story-selector';
import { FcShare } from '../_elements/fc-share/fc-share';
import { FcDownload } from '../_elements/fc-download/fc-download';
import { FcUpgrade } from '../_elements/fc-upgrade/fc-upgrade';
import { FinalcutsControls } from '../_elements/finalcuts-controls/finalcuts-controls';
import { FcInfo } from '../_elements/fc-info/fc-info';
import styles from './_fc-actions.module.scss';

export const FcActions = () => {
  return (
    <div className={styles.FcActions}>
      <StorySelector disableStoriesWithoutFinalcuts />
      <FcInfo />
      <div className={styles.FcActions__upgrade}>
        <FcUpgrade />
        <FcDownload />
        <FcShare className={styles.FcActions__share} />
      </div>
      <FinalcutsControls className={styles.FcActions__footer} />
    </div>
  );
};
